import { render, staticRenderFns } from "./ADescuentoAprobacion.vue?vue&type=template&id=7d72e368"
import script from "./ADescuentoAprobacion.vue?vue&type=script&lang=js"
export * from "./ADescuentoAprobacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports